import React from 'react';
import {
  EligibilityOverviewSubscriber,
} from 'dtos/eligibilityOverviewSubscriber';
import Section from 'views/EMR/components/Eligibility/Overview/Section';
import Field from 'views/EMR/components/Eligibility/Overview/Field';
import Address from 'views/EMR/components/Eligibility/Overview/Address';

type Props = {
  subscriber: EligibilityOverviewSubscriber;
};

export default function Subscriber({ subscriber }: Props) {
  const {
    firstName,
    middleName,
    lastName,
    dateOfBirth,
    gender,
    memberId,
    groupNumber,
    address,
  } = subscriber;

  return (
    <Section title="Subscriber">
      <div className="flex flex-wrap gap-x-6 gap-y-3">
        <Field label="First name" value={firstName} />
        <Field label="Middle name" value={middleName} />
        <Field label="Last name" value={lastName} />
        <Field label="Date of birth" value={dateOfBirth} />
        <Field label="Gender" value={gender} />
        <Field label="Member ID" value={memberId} />
        <Field label="Group number" value={groupNumber} />
      </div>
      <Address address={address} className="mt-4" title="Address" />
    </Section>
  );
}
